window.addEventListener('DOMContentLoaded', (event) => {
  // const indac2 = new RegExp(/indac2/gi);
  // const noz2 = new RegExp(/noz2/gi);
  // document.body.innerHTML = document.body.innerHTML.replaceAll(indac2, "IndAC<sub>2</sub>");
  // document.body.innerHTML = document.body.innerHTML.replaceAll(noz2, "Noz<sub>2</sub>");

  let strings = document.querySelectorAll(".navbar__main-nav li a, .block h1, .block h2, .block h3, .block h4, .block h5, .block h6, .block p, .block li, .block a, .filters__list label, .downloads__item__file, .downloads__item__product");

  strings.forEach((string) => {
    if (string.innerHTML.includes("IndAC2")) {
      string.innerHTML = string.innerHTML.replaceAll("IndAC2", "IndAC<sub>2</sub>");
    }
    if (string.innerHTML.includes("NOZ2")) {
      string.innerHTML = string.innerHTML.replaceAll("NOZ2", "NOZ<sub>2</sub>");
    }
    if (string.innerHTML.includes("IsolAir2")) {
      string.innerHTML = string.innerHTML.replaceAll("IsolAir2", "IsolAir<sub>2</sub>");
    }
    if (string.innerHTML.includes("Comfort Circle2")) {
      string.innerHTML = string.innerHTML.replaceAll("Comfort Circle2", "Comfort Circle<sub>2</sub>");
    }
    if (string.innerHTML.includes("CC2")) {
      string.innerHTML = string.innerHTML.replaceAll("CC2", "Comfort Circle<sub>2</sub>");
    }
    if (string.innerHTML.includes("DoorFlow2")) {
      string.innerHTML = string.innerHTML.replaceAll("DoorFlow2", "DoorFlow<sub>2</sub>");
    }
    if (string.innerHTML.includes("STYLE2")) {
      string.innerHTML = string.innerHTML.replaceAll("STYLE2", "STYLE<sub>2</sub>");
    }
    if (string.innerHTML.includes("Style2")) {
      string.innerHTML = string.innerHTML.replaceAll("Style2", "STYLE<sub>2</sub>");
    }
  });
});